import React from 'react';
import { companyInfo } from '../data/mock';
import { CheckCircle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../data/translations';

const About = () => {
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  return (
    <section id="about" className="about-section">
      <div className="about-header">
        <h2 className="display-large section-title">{t('about.title')}</h2>
        <p className="heading-2 about-subtitle">{t('about.subtitle')}</p>
      </div>

      <div className="about-content">
        <div className="about-text">
          <div className="company-profile">
            <h3 className="heading-2 profile-title">
              {language === 'ar' ? 'نبذة عن الشركة' : 'Company Profile'}
            </h3>
            <p className="body-large about-description">
              {t('about.companyProfile')}
            </p>
            <p className="body-large about-description">
              {t('about.philosophy')}
            </p>
          </div>

          <div className="core-services-section">
            <h3 className="heading-2">{t('about.coreServices.title')}</h3>
            <ul className="core-services-list">
              {t('about.coreServices.items').map((item, index) => (
                <li key={index} className="core-service-item">
                  <CheckCircle size={20} className="service-check-icon" />
                  <span className="body-medium">{item}</span>
                </li>
              ))}
            </ul>
          </div>
          
          <div className="mission-vision">
            <div className="mission">
              <h3 className="heading-2">{t('about.mission.title')}</h3>
              <p className="body-medium">{t('about.mission.text')}</p>
            </div>
            <div className="vision">
              <h3 className="heading-2">{t('about.vision.title')}</h3>
              <p className="body-medium">{t('about.vision.text')}</p>
            </div>
          </div>

          <div className="values-section">
            <h3 className="heading-2">
              {language === 'ar' ? 'قيمنا' : 'Our Values'}
            </h3>
            <div className="values-grid">
              {companyInfo.about.values.map((value, index) => (
                <div key={index} className="value-item">
                  <CheckCircle size={24} className="value-icon" />
                  <div>
                    <h4 className="heading-3">{t(`about.values.${value.key}.title`)}</h4>
                    <p className="body-small">{t(`about.values.${value.key}.description`)}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        <div className="about-image-container">
          <img 
            src="https://images.unsplash.com/photo-1642522029691-029b5a432954" 
            alt="Professional business consultation"
            className="about-image"
          />
        </div>
      </div>
    </section>
  );
};

export default About;
